import { ChangeCircleOutlined } from '@mui/icons-material';
import { Tooltip, Typography } from '@mui/material';
import { SITUACAO_ALTERACAO_MINUTA } from '@/dominio/SituacaoAlteracaoMinuta';
import SituacaoAlteracaoMinutaBusiness from '@/dominio/SituacaoAlteracaoMinutaBusiness';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import ModalConfirmacao from './ModalConfirmacao';
import Configuracao from '@/util/Configuracao';

class AtualizarDecisao extends ReactComponent {
    abrirModalConfirmacao = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            abrirModalConfirmacao: observable,
            registro: computed,
            abrirConfirmacao: action,
            fecharConfirmacao: action,
            handleClickIcone: action
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    abrirConfirmacao = () => {
        this.abrirModalConfirmacao = true;
    };

    fecharConfirmacao = () => {
        this.abrirModalConfirmacao = false;
    };

    handleClickIcone = async () => {
        await this.sessaoService.reiniciarAnaliseDecisao(this.registro);
        if (this.registro.processo.origem === Configuracao.ORIGEM_PJE) {
            await this.salaSessaoStore.carregarRascunhoCertidao();
        }
        this.sessaoStore.recarregarProcesso(this.registro);
        this.mensagemStore.abrirMensagemSucesso('Decisão atualizada com sucesso.');
        this.abrirModalConfirmacao = false;
    };

    habilitar() {
        if (
            !this.parametroStore.isOrgaoTST ||
            this.registro.necessitaImportacaoSalaSessao ||
            this.registro.certidaoGerada
        ) {
            return false;
        }
        return (
            SituacaoAlteracaoMinutaBusiness.getStatusMinuta(this.registro)?.texto ===
            SITUACAO_ALTERACAO_MINUTA.ALTERADA.descricao
        );
    }

    render() {
        if (!this.habilitar()) {
            return null;
        }
        return (
            <div>
                <Tooltip
                    title={'Atualizar decisão e remover indicação de minuta alterada'}
                    placement="top-start"
                >
                    <ChangeCircleOutlined
                        data-testid="atualizar-decisao"
                        onClick={this.abrirConfirmacao}
                        style={{ cursor: 'pointer', width: '24px', height: '24px', marginRight: '8px' }}
                    />
                </Tooltip>
                {this.renderConfirmacao()}
            </div>
        );
    }

    renderConfirmacao() {
        return (
            <ModalConfirmacao
                titulo={'Atualizar decisão'}
                open={this.abrirModalConfirmacao}
                callbackCancelar={this.fecharConfirmacao}
                callbackConfirmar={this.handleClickIcone}
            >
                <Typography display={'inline'}>
                    O texto da nova decisão será copiado sobre o atual rascunho da certidão. Deseja prosseguir?
                </Typography>
            </ModalConfirmacao>
        );
    }
}

export default inject('stores')(observer(AtualizarDecisao));
